import { render } from "./account-menu.vue?vue&type=template&id=56eb23e7&scoped=true"
import script from "./account-menu.vue?vue&type=script&lang=ts"
export * from "./account-menu.vue?vue&type=script&lang=ts"

import "./account-menu.vue?vue&type=style&index=0&id=56eb23e7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56eb23e7"

export default script